__turbopack_context__.v({
  "closeButton": "MobileMenu-module__Y5z5tq__closeButton",
  "hamburger": "MobileMenu-module__Y5z5tq__hamburger",
  "overlay": "MobileMenu-module__Y5z5tq__overlay",
  "overlayContainer": "MobileMenu-module__Y5z5tq__overlayContainer",
  "rightMobile": "MobileMenu-module__Y5z5tq__rightMobile",
  "voucherButton": "MobileMenu-module__Y5z5tq__voucherButton",
});
